const VISUALIZER = '[Visualizer]';

const types = {
	warn: '[WARN]',
	error: '[ERROR]',
	info: '[INFO]'
};

export function warning(message: string) {
	console.warn(`${VISUALIZER} ${types.warn}: `, message);
}

export function errorMessage(message: string) {
	console.error(`${VISUALIZER} ${types.error}: `, message);
}

export function info(message: string) {
	console.info(`${VISUALIZER} ${types.info}: `, message);
}

export class GenericError extends Error {
	constructor(message: string) {
		super(`${VISUALIZER} ${types.error}: ${message}`);
	}
}
